import { FilterMatchMode } from "primereact/api";

export class Cliente {
    model = {
        id: {
            value: null,
            export: false,
            header: 'Código',
            table: false,
            showFilterMatchModes: false,
            headerStyle: { width: '10%', minWidth: '10rem' }
        },
        nombres: {
            value: '',
            export: false,
            table: true,
            header: 'Nombres',
            required: 'El nombres es requerido',
            max: 400, min: 4,
            minLength: 'Mínimo 4 caracteres',
            sort: true,
            filter: true,
            filterField: 'nombres',
            matchMode: FilterMatchMode.CONTAINS,
            frozen: true,
            headerStyle: { minWidth: '200px' },
        },
        empresa: {
            value: '',
            export: false,
            table: true,
            header: 'Empresa',
            required: 'La empresa es requerida',
            sort: true,
            filter: true,
            filterField: 'empresa',
            matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { minWidth: '200px' },
        },
        tipo_identificacion: {
            value: '',
            export: false,
            table: true,
            header: 'Tipo de Identificación',
            required: 'El tipo de identificación es requerido',
            sort: true,
            filter: true,
            filterField: 'tipo_identificacion',
            matchMode: FilterMatchMode.IN,
            isMultiselect: true,
            catalogKey: 'tipo_identificacion',
            headerStyle: { minWidth: '200px' }
        },
        identificacion: {
            value: '',
            export: false,
            table: true,
            header: 'Identificación',
            required: 'La identificación es requerida',
            max: 20, min: 4,
            minLength: 'Mínimo 4 caracteres',
            filter: true,
            filterField: 'identificacion',
            matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { minWidth: '200px' }
        },
        pais_id: {
            value: '',
            export: false,
            table: false,
            header: 'País',
            required: 'El país es requerido',
            headerStyle: { minWidth: '200px' }
        },
        provincia_id: {
            value: '',
            export: false,
            table: false,
            header: 'Provincia',
            required: 'La provincia es requerida',
            headerStyle: { minWidth: '200px' }
        },
        ciudad_id: {
            value: '',
            export: false,
            table: false,
            header: 'Ciudad',
            required: 'La ciudad es requerida',
            headerStyle: { minWidth: '200px' }
        },
        ciudad: {
            value: '',
            export: false,
            table: false,
            header: 'Ciudad',
            required: 'La ciudad es requerida',
            max: 250, min: 4,
            minLength: 'Mínimo 4 caracteres',
            headerStyle: { minWidth: '200px' }
        },
        direccion: {
            value: '',
            export: false,
            table: false,
            header: 'Dirección',
            required: 'La dirección es requerida',
            max: 350, min: 4,
            maxLength: 'Máximo 350 caracteres',
            minLength: 'Mínimo 4 caracteres',
            headerStyle: { minWidth: '200px' }
        },
        ingreso_mensual: {
            value: null,
            export: false,
            table: true,
            header: 'Ingreso Mensual',
            required: 'Ingreso Mensual es requerido',
            isNumeric: true,
            isCurrency: true,
            headerStyle: { minWidth: '150px' },
        },
        egreso_mensual: {
            value: null,
            export: false,
            table: true,
            header: 'Egreso Mensual',
            required: 'Egreso Mensual es requerido',
            isNumeric: true,
            isCurrency: true,
            headerStyle: { minWidth: '150px' }
        },
        ingreso_mensual_neto: {
            value: null,
            export: false,
            table: true,
            header: 'Ingreso Mensual Neto',
            required: 'Ingreso Mensual Neto es requerido',
            isNumeric: true,
            isCurrency: true,
            headerStyle: { minWidth: '150px' }
        },
        activo: {
            value: null,
            export: false,
            header: 'Activos',
            table: true,
            required: 'Activo es requerido',
            isNumeric: true,
            isCurrency: true,
            headerStyle: { minWidth: '150px' }
        },
        pasivo: {
            value: null,
            export: false,
            table: true,
            header: 'Pasivos',
            required: 'Pasivo es requerido',
            isNumeric: true,
            isCurrency: true,
            headerStyle: { minWidth: '150px' }
        },
        patrimonio: {
            value: null,
            table: true,
            export: false,
            header: 'Patrimonio',
            required: 'Patrimonio es requerido',
            isNumeric: true,
            isCurrency: true,
            headerStyle: { minWidth: '150px' }
        },
        fecha: {
            value: null,
            table: true,
            export: false,
            header: 'Fecha',
            required: 'Fecha es requerido',
            filterField: 'fecha',
            filter: true, sort: true, isDate: true,
            headerStyle: { minWidth: '200px' },
            body: (rowData) => {
                if (!rowData.fecha) return null;
                return new Date(rowData.fecha + 'T00:00:00').toLocaleDateString(); // Media noche hora local
            }
        }
    };

    template = (body, info, columnasExtra) => {
        const headers = [
            { text: 'N°', style: 'th' },
            { text: 'Nombres', style: 'th' },
            { text: 'Empresa', style: 'th' },
            { text: 'Identificación', style: 'th' },
            { text: 'País', style: 'th' },
            { text: 'Provincia', style: 'th' },
            { text: 'Ciudad', style: 'th' },
            { text: 'Dirección', style: 'th' },
        ];
        if (columnasExtra.incluirTipoPersona) {
            headers.push({ text: 'Tipo de persona', style: 'th' });
        }
        headers.push(
            { text: 'Ingreso mensual', style: 'th' },
            { text: 'Egreso mensual', style: 'th' },
            { text: 'Ingreso neto', style: 'th' },
            { text: 'Activo', style: 'th' },
            { text: 'Pasivo', style: 'th' },
            { text: 'Patrimonio', style: 'th' },
            { text: 'Fecha', style: 'th' }
        );

        return {
            pageOrientation: 'landscape',
            pageSize: 'A3',
            pageMargins: [40, 100, 40, 40],
            header: {
                margin: [40, 20, 40, 20],
                columns: [
                    info.logo
                        ? { image: info.logo, width: 80, alignment: 'left' }
                        : { text: '', width: 80 },
                    {
                        stack: [
                            { text: 'Listado de Clientes', style: 'header', alignment: 'center', margin: [0, 0, 0, 5] },
                            { text: info.razon_social || '', alignment: 'center', bold: true, fontSize: 10, margin: [0, 0, 0, 2] },
                            {
                                text: [
                                    { text: 'Fecha de generación del reporte: ', bold: true },
                                    { text: info.fecha_generacion || '' }
                                ],
                                alignment: 'center', fontSize: 9
                            }
                        ],
                        width: '*'
                    },
                    { text: '', width: 80 }
                ]
            },
            footer: (currentPage, pageCount) => ({
                columns: [
                    { text: '', width: '33%' },
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'center', fontSize: 9, width: '34%' },
                    { text: `Total de clientes: ${info.total_clientes || ''}`, alignment: 'right', fontSize: 9, width: '33%' }
                ],
                margin: [40, 10, 40, 0]
            }),
            content: [
                {
                    table: {
                        headerRows: 1,
                        widths: [25, 80, 110, ...Array(headers.length - 3).fill('*')],
                        body: [headers, ...body]
                    },
                    layout: {
                        fillColor: function (rowIndex, node, columnIndex) {
                            return rowIndex === 0 ? '#eeeeee' : null;
                        },
                        hLineColor: '#ccc',
                        vLineColor: '#ccc',
                        paddingLeft: () => 4,
                        paddingRight: () => 4
                    }
                }
            ],
            styles: {
                header: { fontSize: 16, bold: true },
                th: { bold: true, fontSize: 8, color: '#000000' }
            },
            defaultStyle: {
                alignment: 'center',
                fontSize: 7
            }
        };
    };
}
